import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RirekishoOptions } from '@src/api/core/api-types';

const initialState: RirekishoOptions = {
  insertBlankLine: true,
  showGender: true,
  showPhoto: true,
};

const rirekishoOptionsSlice = createSlice({
  name: 'rirekishoOptions',
  initialState,
  reducers: {
    updateRirekishoOptions: (state, action: PayloadAction<Partial<RirekishoOptions>>) => {
      return { ...state, ...action.payload };
    },
    resetRirekishoOptions: () => initialState,
  },
});

export const { updateRirekishoOptions } = rirekishoOptionsSlice.actions;

export default rirekishoOptionsSlice.reducer;
